import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ProductListing from "@/components/product/ProductListing";
import { getCategories } from "@/services/catalog";

export default function CategoryPage() {
  const { slug } = useParams();
  const { data: categories = [] } = useQuery({ queryKey: ["categories"], queryFn: getCategories });
  const category = categories.find((c) => c.slug === slug);
  return <ProductListing title={category?.name || slug} baseParams={{ category: slug }} />;
}
